import { FC } from 'react';
import { Box, Table, TableBody, TableRow } from '@mui/material';
import DBHeader from 'src/components/Headers/DialogBoxHeader';
import Scrollbar from 'src/components/StyledComponents/StyledScrollbar';
import { StyledDialogContent } from 'src/components/DialogBox/DialogBox.styles';
import {
  CloseIcon,
  StyledDialog,
} from 'src/components/DialogBox/DialogBox.styles';
import { ProductionMapping } from 'src/models/Management.interface';
import {
  StyledTableContainer,
  StyledTableHead,
  StyledTableRow,
  StyledTableCell,
} from 'src/components/StyledComponents/StyledTable';
import { StyledText } from 'src/components/StyledComponents/StyledPageComponents';

interface ProductionMappingViewDialogProps {
  open: boolean;
  handleClose: () => void;
  mapping: ProductionMapping | null;
  title: string;
  subtitle: string;
}

const ProductionMappingViewDialog: FC<ProductionMappingViewDialogProps> = ({
  open,
  handleClose,
  mapping,
  title,
  subtitle,
}) => {
  const rawMaterials = mapping?.details || mapping?.rawMaterialDetails || [];

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      width="550px"
      height="550px"
    >
      <Box sx={{ position: 'relative' }}>
        <DBHeader title={title} subtitle={subtitle} />
        <CloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </Box>
      <Scrollbar thumbColor="var(--loader-color)">
        <StyledDialogContent>
          <Box ml={5} mr={5} mt={1.5} mb={1}>
            <Box display="flex" alignItems="center" mb={1}>
              <StyledText fontWeight={600} marginRight="8px">
                Product :
              </StyledText>
              <StyledText fontWeight={300}>
                {mapping?.productName || 'N/A'}
              </StyledText>
            </Box>
            <StyledText fontWeight={600}>Raw Materials</StyledText>
            <StyledTableContainer>
              <Table>
                <StyledTableHead>
                  <TableRow>
                    <StyledTableCell component="th" align="center" width="10%">
                      #
                    </StyledTableCell>
                    <StyledTableCell component="th">
                      Raw Material Name
                    </StyledTableCell>
                    <StyledTableCell component="th" align="right">
                      Quantity
                    </StyledTableCell>
                  </TableRow>
                </StyledTableHead>
                <TableBody>
                  {rawMaterials.length > 0 ? (
                    rawMaterials.map((detail, index) => (
                      <StyledTableRow key={detail.id}>
                        <StyledTableCell align="center">
                          {index + 1}
                        </StyledTableCell>
                        <StyledTableCell>
                          {detail.rawMaterialName}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {detail.quantity}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell colSpan={3} align="center">
                        No raw materials found
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </StyledTableContainer>
          </Box>
        </StyledDialogContent>
      </Scrollbar>
    </StyledDialog>
  );
};

export default ProductionMappingViewDialog;
